export const links = [
  {
    id: 1,
    link: "dubai expo exhibition",
    type: "competition",
    realized: true,
    year: "2021",
    img: "bg_dubai.jpg",
  },
  {
    id: 2,
    link: "helsinki park design",
    type: "competition",
    realized: false,
    year: "2020",
    img: "bg_park.jpg",
  },
  {
    id: 3,
    link: "computational design",
    type: "university projects",
    realized: false,
    year: "2022",
    img: "bg_comp.jpg",
  },
  {
    id: 4,
    link: "hotel projects",
    type: "university projects",
    realized: false,
    year: "2019 | 2021",
    img: "bg_hotel.jpg",
  },
  // {
  //   id: 5,
  //   link: "interior design",
  //   type: "job-realated projects",
  //   realized: false,
  //   year: "2020 - 2022",
  //   img: "bg_interior.jpg",
  // },
  {
    id: 5,
    link: "publications",
    type: "university / private initiative",
    realized: false,
    year: "2019 - 2021",
    img: "bg_publications.jpg",
  },
  {
    id: 6,
    link: "ukraine expedition",
    type: "university",
    realized: false,
    year: "2019",
    img: "bg_hucu.jpg",
  },
];
